import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import PropTypes from "prop-types";
import config from "../../src/config";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../src/utils/global/localData";
import { jwtDecode } from "jwt-decode";

const SocketContext = createContext();
// Hook to use socket context data
export const useSocketContext = () => {
  return useContext(SocketContext);
};
export const SocketContextProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  const socketHandler = async () => {
    const token = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    if (token) {
      const decoded = jwtDecode(token);
      const userId = decoded.user.id;
      
      // Create the socket connection
      const newSocket = io(config.SOCKETURL, {
        withCredentials: true,
        auth: {
          token: `Bearer ${token}`,
        },
        extraHeaders: {
          Authorization: `Bearer ${token}`,
        },
        query: {
          userId // Send the userId when connecting
        }
      });

      newSocket.on("connect", () => {
        // console.log("Socket connected successfully:", newSocket.id);
        setSocket(newSocket);
      });

      newSocket.on("connect_error", (error) => {
        // console.error('Socket connection error:', error);
      });

      newSocket.on("disconnect", () => {
        // console.log('Socket disconnected');
      });

      return () => {
        newSocket.close();
        setSocket(null);
      };
    } else {
      if (socket) {
        socket.close();
        setSocket(null);
      }
    }
  };
  useEffect(() => {
    socketHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <SocketContext.Provider
      value={{
        socket,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};
SocketContextProvider.propTypes = {
  children: PropTypes.node,
};
